import { Component, computed, input } from "@angular/core";
import { EligibilityViewRuleComponent } from "./eligibility-view-rule.component";

export interface EligibilityRule {
    op: string;
    result: boolean;
    description: string;
    args: EligibilityRule[];
}

@Component({
    selector: 'eas-eligibility-view',
    templateUrl: 'eligibility-view.component.html',
    styleUrls: ['./eligibility-view.component.css'],
    imports: [
        EligibilityViewRuleComponent
    ]
})
export class EligibilityViewComponent {

    eligibility = input.required<EligibilityRule>();
    eligibilityRule = computed(() => this.eligibility().args?.length == 1 ? this.eligibility().args[0] : this.eligibility());
}
